import { css } from 'styled-components';
import { globalTheme } from '@clds/component-theme';

export const depthCss = css`
  ${({ depth, ...props }) => `calc(${depth} * ${globalTheme.spacing.lg(props)} + ${globalTheme.spacing.xxs(props)})`};
`;
